import React from "react";

const Terms = () => {
  return (
    <div className="bg-slate-100 py-10 md:py-24">
      <div className="container mx-auto px-5 md:px-24">
        <div className="bg-white rounded-lg shadow p-10">
          <h5 className="font-bold md:text-4xl text-2xl text-center md:text-start">
            Terms of Use for GreenGPT Crypto Token Project
          </h5>
          <div className="md:mt-10">
            <p className="md:text-lg mt-5 text-justify md:text-start">
              Welcome to GreenGPT, a crypto token project that combines Ask to
              Earn service, AI blockchain-based service, auto-staking, and
              auto-burning features to promote environmental sustainability. By
              accessing and using our platform, you agree to the following
              terms:
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">1. Ask to Earn Service:</span>
              Our Ask to Earn service allows users to earn cryptocurrency
              rewards by answering questions or performing tasks related to
              environmental sustainability. Users must provide accurate and
              reliable information, and any fraudulent or deceptive activity is
              strictly prohibited.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">
                2. AI Blockchain-Based Service:
              </span>
              Our AI blockchain-based service uses artificial intelligence to
              analyze data on environmental sustainability, create smart
              contracts, and develop decentralized applications. Users
              acknowledge that the AI-based services are provided "as is" and do
              not guarantee absolute accuracy or reliability.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">3. Auto-Staking:</span>
              Our platform includes auto-staking features where a percentage of
              transferred tokens are automatically staked. Users acknowledge
              that staking is subject to risks, including potential loss of
              tokens, and should carefully review the staking terms and
              conditions before participating.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">4. Auto-Burning:</span>
              Our platform also includes auto-burning features where a
              percentage of tokens are automatically burned, reducing the
              overall token supply. Users acknowledge that auto-burning is
              irreversible and cannot be undone.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">5. Ownership and Use:</span> Users
              acknowledge that the GreenGPT tokens and associated intellectual
              property rights are owned by GreenGPT, and users are granted
              limited, non-transferable rights to use the tokens solely for
              their intended purpose on the platform.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">6. Compliance with Laws:</span>
              Users agree to comply with all applicable laws, regulations, and
              rules when using the GreenGPT platform, including but not limited
              to anti-money laundering (AML) and know-your-customer (KYC)
              requirements.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">7. Disclaimer of Liability:</span>
              Users acknowledge that GreenGPT is not responsible for any loss,
              damage, or liability arising from the use of the platform,
              including but not limited to any errors, omissions, or
              inaccuracies in the AI-based services or any actions taken based
              on the information provided.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">8. Indemnification:</span>
              Users agree to indemnify, defend, and hold harmless GreenGPT and
              its affiliates, officers, directors, employees, and agents from
              and against any claims, damages, losses, liabilities, and expenses
              arising from their use of the platform.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">
                9. Modifications and Termination:
              </span>
              GreenGPT reserves the right to modify or terminate the platform,
              services, or these terms of use at any time, without prior notice.
              Users are responsible for reviewing the most current version of
              the terms of use regularly.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">
                10. Governing Law and Jurisdiction:
              </span>
              These terms of use shall be governed by and construed in
              accordance with the laws of [Jurisdiction], and any disputes
              arising out of or relating to these terms or the use of the
              platform shall be resolved exclusively by the courts of
              [Jurisdiction].
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              <span className="font-bold ">11. Entire Agreement:</span> These
              terms of use constitute the entire agreement between the user and
              GreenGPT regarding the use of the platform, superseding any prior
              or contemporaneous agreements or understandings, whether written
              or oral.
            </p>
            <p className="md:text-lg mt-5 text-justify md:text-start">
              By accessing and using the GreenGPT platform, you acknowledge that
              you have read, understood, and agreed to these terms of use. If
              you do not agree to these terms, please do not use the GreenGPT
              platform.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
